"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showBar = showBar;
exports.SurveyHeader = void 0;

var _Discussion = babelHelpers.interopRequireDefault(require("components/Discussion"));

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _ProfileImageContainer = babelHelpers.interopRequireDefault(require("components/ProfileImageContainer"));

var _decorators = require("decorators");

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _temp;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function showBar(node, discussionRoot, userId, catalogItem, campaign) {
  var showIt = !!campaign;

  if (!showIt) {
    node.style.display = 'none';

    _Discussion.default.getDiscussion(discussionRoot).then(function (discussion) {
      discussion.getDiscussionRoot().then(function (root) {
        if (root.node.survey) {
          node.style.display = '';
          innerShowBar(node, discussionRoot, userId, catalogItem, campaign);
        }
      });
    });

    return;
  }

  innerShowBar(node, discussionRoot, userId, catalogItem, campaign);
}

function innerShowBar(node, discussionRoot, userId, catalogItem, campaign) {
  _reactDom.default.render(_react.default.createElement(SubmissionInfoBar, {
    discussionRoot: discussionRoot,
    userId: userId,
    catalogItem: catalogItem,
    campaign: campaign
  }), node);
}

var SubmissionInfoBar = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(SubmissionInfoBar, _Component);

  function SubmissionInfoBar() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, SubmissionInfoBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(SubmissionInfoBar)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "discussionRoot", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "userId", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "catalogItem", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "campaign", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.state = {
      rootNode: null
    };
    return _this;
  }

  babelHelpers.createClass(SubmissionInfoBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      _Discussion.default.getDiscussion(this.discussionRoot).then(function (discussion) {
        discussion.getDiscussionRoot().then(function (root) {
          _this2.setState({
            discussion: discussion,
            rootNode: root
          });
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "submission-info-bar-content"
      }, this.campaign && _react.default.createElement(Campaign, this.campaign), this.state.rootNode && this.state.rootNode.node.survey && _react.default.createElement(Survey, _extends({}, this.state.rootNode.node.survey, {
        catalogItem: this.props.catalogItem,
        discussion: this.state.discussion
      })));
    }
  }]);
  return SubmissionInfoBar;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "discussionRoot", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "userId", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "catalogItem", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "campaign", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);

var MaybeLink = function MaybeLink(_ref) {
  var href = _ref.href,
      className = _ref.className,
      children = _ref.children;
  return href ? _react.default.createElement("a", {
    className: className,
    href: href
  }, children) : _react.default.createElement("div", {
    className: className
  }, children);
};

var Campaign = function Campaign(_ref2) {
  var title = _ref2.title,
      link = _ref2.link,
      image = _ref2.image;
  return _react.default.createElement(MaybeLink, {
    href: link,
    className: "campaign-detail"
  }, image && _react.default.createElement("div", {
    className: "campaign-image",
    style: {
      backgroundImage: "url(".concat(image, ")")
    }
  }), _react.default.createElement("div", {
    className: "campaign-title"
  }, title), link && _react.default.createElement("div", {
    className: "campaign-cta"
  }, "View all submissions"));
};

var SurveyHeader = function SurveyHeader(_ref3) {
  var callToAction = _ref3.callToAction,
      catalogItem = _ref3.catalogItem;
  return _react.default.createElement("div", null, _react.default.createElement("h1", {
    className: "survey-header"
  }, callToAction), _react.default.createElement("div", {
    className: "catalog-item"
  }, _react.default.createElement("div", {
    className: "photo"
  }, _react.default.createElement("div", {
    className: "list-image",
    style: {
      backgroundImage: "url(".concat(catalogItem.image, ")")
    }
  })), _react.default.createElement("div", {
    className: "catalog-item-info"
  }, _react.default.createElement("div", {
    className: "catalog-item-title"
  }, catalogItem.title), catalogItem.people.map(function (person, index) {
    return _react.default.createElement(MaybeLink, {
      className: "catalog-item-person",
      href: person.link,
      key: index
    }, _react.default.createElement(_ProfileImageContainer.default, {
      componentName: "div",
      className: "person-profile-image",
      noImageClassName: "initials",
      image: person.image,
      name: person.name
    }), _react.default.createElement("div", {
      className: "person-name"
    }, person.name));
  }))));
};

exports.SurveyHeader = SurveyHeader;

var Survey = function Survey(_ref4) {
  var callToAction = _ref4.callToAction,
      promoText = _ref4.promoText,
      catalogItem = _ref4.catalogItem,
      discussion = _ref4.discussion;
  return _react.default.createElement("div", {
    className: "survey"
  }, _react.default.createElement("span", {
    className: "material-icons",
    "data-icon": "record_voice_over"
  }), promoText && _react.default.createElement("div", {
    className: "survey-callout"
  }, promoText), _react.default.createElement("a", {
    href: "javascript:void(0)",
    onClick: function onClick() {
      return discussion.leaveSurveyResponse(_react.default.createElement(SurveyHeader, {
        callToAction: callToAction,
        catalogItem: catalogItem
      }));
    }
  }, callToAction || 'Leave your feedback'));
};